"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTypeExportLayout = exports.EntityTypeExportLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_lang_1 = require("../../hooks/use-lang");
var client_1 = require("@apollo/client");
var icon_button_1 = require("../elements/icon-button");
var loader_1 = require("../elements/loader");
var cls = (0, utils_1.classNames)('entity-export-layout');
var file_saver_1 = require("file-saver");
var XLSX = __importStar(require("xlsx"));
var lodash_1 = require("lodash");
var sprintf_js_1 = require("sprintf-js");
var flatten_json_1 = require("../../utils/flatten-json");
var dialog_1 = require("../elements/dialog");
var error_message_1 = require("../elements/error-message");
var current_user_can_1 = require("../../utils/current-user-can");
var markdown_1 = require("../elements/markdown");
var use_entities_1 = require("../../hooks/use-entities");
var use_modal_1 = require("../../hooks/use-modal");
var entity_type_icon_1 = require("./entity-type-icon");
var to_array_1 = require("../../utils/to-array");
var insert_empty_objects_1 = require("../../utils/insert-empty-objects");
var use_active_person_1 = require("../../hooks/use-active-person");
var react_ga4_1 = __importDefault(require("react-ga4"));
exports.EntityTypeExportLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 600px;\n    width: 80vw;\n    background: #FFF;\n    min-width: 280px;\n  "], ["\n    max-width: 600px;\n    width: 80vw;\n    background: #FFF;\n    min-width: 280px;\n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DownloadButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-transform: none;\n    white-space: normal;\n    font-size: ", ";\n    .shp--icon-button__label {\n      white-space: normal;\n      text-align: left;\n    }\n  "], ["\n    text-transform: none;\n    white-space: normal;\n    font-size: ", ";\n    .shp--icon-button__label {\n      white-space: normal;\n      text-align: left;\n    }\n  "])), theme_1.theme.FONT_SIZE(15))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["  \n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    gap: ", ";\n    padding-bottom: ", ";\n  "], ["  \n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    gap: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(6), theme_1.theme.UNIT(2))
});
var MessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Body: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  DownloadButton: (0, styled_components_1.default)(icon_button_1.DownloadIconButton)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DownloadButtonStyles),
  Message: (0, styled_components_1.default)(markdown_1.Markdown)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};
var EntityTypeExportLayout = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    entityTypeName = props.entityTypeName;
  var defn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var entities = (0, use_entities_1.useEntities)();
  var user = (0, use_active_person_1.useActivePerson)();
  var canAdmin = (0, current_user_can_1.currentUserCanAdmin)();
  var allName = defn.allName;
  var query = defn.export.query;
  var _b = (0, client_1.useQuery)(query),
    loading = _b.loading,
    data = _b.data;
  var allRecords = (data === null || data === void 0 ? void 0 : data[allName]) || [];
  // now look at the worksheet definitions, if any, and split those fields out into other sets
  var records = __spreadArray([], __read(allRecords), false);
  var worksheets = (0, lodash_1.filter)((defn.export.worksheets || []).map(function (worksheet) {
    // topicExpertise -- linked multiple
    // process all records under the field 
    var worksheetRecords = (0, lodash_1.flatten)((0, lodash_1.map)(records, function (record) {
      var _a;
      var worksheetValue = record[worksheet.field];
      // reverse map the master record details back to this record
      var reverseRecord = (_a = {}, _a[defn.singleTypeName] = (0, lodash_1.pick)(record, (0, lodash_1.uniq)(__spreadArray(__spreadArray([], __read(worksheet.reverseFields || ['name', 'slug']), false), __read(worksheet.extraReverseFields || []), false))), _a);
      if (worksheetValue) {
        return (0, lodash_1.map)((0, to_array_1.toArray)(worksheetValue), function (value) {
          var _a;
          if ((0, lodash_1.isObject)(value)) {
            return __assign(__assign({}, reverseRecord), value);
          }
          // if the object was scalar, this doesn't make sense, but just return it using the worksheet field name  
          return __assign(__assign({}, reverseRecord), (_a = {}, _a[worksheet.field] = value, _a));
        });
      }
    }));
    var flattenedWorksheet = (0, flatten_json_1.flattenJsonArray)(worksheetRecords);
    // now that we've processed the worksheet fields, remove them from the main records (which fall under these keys)
    records = (0, lodash_1.map)(records, function (record) {
      return (0, lodash_1.omitBy)(record, function (value, key) {
        return (0, lodash_1.startsWith)(key, worksheet.field);
      });
    });
    var finalWorksheetRecords = (0, lodash_1.map)(flattenedWorksheet, function (record) {
      return (0, lodash_1.omitBy)(record, function (v, k) {
        return k.includes('__type');
      });
    });
    if (worksheet.sort) {
      finalWorksheetRecords = worksheet.sort(finalWorksheetRecords);
    } else if (worksheet.sortByField) {
      finalWorksheetRecords = (0, lodash_1.sortBy)(finalWorksheetRecords, worksheet.sortByField);
    }
    if (worksheet.transformRecord) {
      finalWorksheetRecords = finalWorksheetRecords.map(worksheet.transformRecord);
    }
    if (worksheet.groupByField) {
      if (worksheet.dittoFields && worksheet.dittoFields.length) {
        finalWorksheetRecords = (0, insert_empty_objects_1.insertEmptyObjectsWithDitto)(finalWorksheetRecords, worksheet.groupByField, worksheet.dittoFields, worksheet.dittoMark, worksheet.dittoMarkRepeat, true);
      } else {
        finalWorksheetRecords = (0, insert_empty_objects_1.insertEmptyObjects)(finalWorksheetRecords, worksheet.groupByField, true);
      }
    }
    // remove ContentNode `.text` 
    finalWorksheetRecords = (0, lodash_1.map)(finalWorksheetRecords, function (record) {
      return (0, lodash_1.mapKeys)(record, function (value, key) {
        return key.replace(/\.text$/, '');
      });
    });
    return {
      name: worksheet.name,
      records: finalWorksheetRecords
    };
  }), function (worksheet) {
    return !!worksheet.records.length;
  });
  var flattened = (0, flatten_json_1.flattenJsonArray)(records);
  var all = (0, lodash_1.map)(flattened, function (obj) {
    return typeof obj === 'object' && !Array.isArray(obj) && (0, lodash_1.omitBy)((0, lodash_1.pickBy)(obj), function (v, k) {
      return k.includes('__type');
    });
  });
  var fieldKeys = (0, lodash_1.keys)((_a = defn.form) === null || _a === void 0 ? void 0 : _a.fields);
  var everyKey = [];
  var keySort = function (keys) {
    return keys.sort(function (a, b) {
      var aIndex = a === "id" ? 20000 : (0, lodash_1.findIndex)(fieldKeys, function (key) {
        return (0, lodash_1.startsWith)(a, key);
      });
      var bIndex = b === "id" ? 20000 : (0, lodash_1.findIndex)(fieldKeys, function (key) {
        return (0, lodash_1.startsWith)(b, key);
      });
      var aFinalIndex = aIndex === -1 ? 10000 : aIndex;
      var bFinalIndex = bIndex === -1 ? 10000 : bIndex;
      return aFinalIndex - bFinalIndex;
    });
  };
  var sorted = (0, lodash_1.map)(all, function (obj) {
    var allKeys = keySort((0, lodash_1.keys)(obj));
    everyKey = (0, lodash_1.uniq)(__spreadArray(__spreadArray([], __read(everyKey), false), __read(allKeys), false));
    return (0, lodash_1.zipObject)(allKeys, (0, lodash_1.map)(allKeys, function (key) {
      return obj[key];
    }));
  });
  var getFieldType = function (key) {
    var e_1, _a;
    var _b, _c, _d, _e;
    var parts = (0, lodash_1.filter)(key.split('.'), function (part) {
      return !part.match(/^\d+$/g);
    });
    if (parts.length) {
      var activeEntityDefn = defn;
      try {
        for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
          var part = parts_1_1.value;
          if ((0, lodash_1.includes)(['created', 'updated'], part)) {
            return 'date';
          }
          var fieldDefn = (_b = activeEntityDefn === null || activeEntityDefn === void 0 ? void 0 : activeEntityDefn.form) === null || _b === void 0 ? void 0 : _b.fields[part];
          if (fieldDefn) {
            if (fieldDefn.type === 'linkedTable' || fieldDefn.type === 'linkedMultiple' || fieldDefn.type === 'linked') {
              // move to the new entity definition
              activeEntityDefn = entities[fieldDefn.entityTypeName];
            } else {
              return fieldDefn.type;
            }
          }
          if ((_d = (_c = activeEntityDefn === null || activeEntityDefn === void 0 ? void 0 : activeEntityDefn.export) === null || _c === void 0 ? void 0 : _c.fieldTypes) === null || _d === void 0 ? void 0 : _d[part]) {
            return activeEntityDefn.export.fieldTypes[part];
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
    return (_e = defn.form.fields[key]) === null || _e === void 0 ? void 0 : _e.type;
  };
  var transformed = (0, lodash_1.map)(sorted, function (record) {
    return (0, lodash_1.mapValues)(record, function (value, key) {
      var fieldType = getFieldType(key);
      if (fieldType === 'date') {
        return (0, utils_1.formatDateString)((0, lodash_1.toString)(value), 'DD-MMM-YYYY');
      }
      if (fieldType === 'datetime') {
        return (0, utils_1.formatDateString)((0, lodash_1.toString)(value), 'DD-MMM-YYYY hh:mm:ss A', 'YYYY-MM-DDTHH:mm:ss.SSS');
      }
      return value;
    });
  });
  var finalKeys = keySort(everyKey).map(function (key) {
    return key.replace(/\.text$/, '');
  });
  var fileName = "".concat(process.env.PLATFORM_NAME, " - ").concat(defn.pluralLabel, " - ").concat((0, utils_1.formatDate)(new Date(), 'YYYY-MM-DD'), ".xlsx");
  var mainWorksheet = transformed;
  if (defn.export.transformRecord) {
    mainWorksheet = mainWorksheet.map(defn.export.transformRecord);
  }
  if (defn.export.sort) {
    mainWorksheet = defn.export.sort(mainWorksheet);
  } else if (defn.export.sortByField) {
    mainWorksheet = (0, lodash_1.sortBy)(mainWorksheet, defn.export.sortByField);
  }
  if (defn.export.groupByField) {
    mainWorksheet = (0, insert_empty_objects_1.insertEmptyObjects)(mainWorksheet, defn.export.groupByField, true);
  } else {
    mainWorksheet = (0, insert_empty_objects_1.prependEmptyObject)(mainWorksheet);
  }
  // now remove any contentNode .text values
  mainWorksheet = (0, lodash_1.map)(mainWorksheet, function (record) {
    return (0, lodash_1.mapKeys)(record, function (value, key) {
      return key.replace(/\.text$/, '');
    });
  });
  var friendlyKey = function (key) {
    return key.split('.').map(function (part) {
      return (0, lodash_1.startCase)(part);
    }).join(defn.export.friendlyHeaderGlue);
  };
  var headerKeys = (0, lodash_1.invert)((0, lodash_1.keyBy)(finalKeys, friendlyKey));
  var header = defn.export.useFriendlyHeaders ? (0, lodash_1.map)(finalKeys, friendlyKey) : finalKeys;
  var finalMainWorksheet = defn.export.useFriendlyHeaders ? mainWorksheet.map(function (record) {
    return (0, lodash_1.mapKeys)(record, function (value, key) {
      return headerKeys[key];
    });
  }) : mainWorksheet;
  var exportToExcel = function () {
    var e_2, _a;
    var _b, _c;
    var worksheet = XLSX.utils.json_to_sheet(finalMainWorksheet, {
      header: header
    });
    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, defn.pluralLabel);
    var _loop_1 = function (worksheetDefn) {
      var worksheetKeys = worksheetDefn.records.reduce(function (acc, record) {
        return (0, lodash_1.uniq)(__spreadArray(__spreadArray([], __read(acc), false), __read((0, lodash_1.keys)(record)), false));
      }, []);
      var worksheetHeaderKeys = (0, lodash_1.invert)((0, lodash_1.keyBy)(worksheetKeys, friendlyKey));
      var worksheetHeader = defn.export.useFriendlyHeaders ? (0, lodash_1.map)(worksheetKeys, friendlyKey) : worksheetKeys;
      var worksheetData = defn.export.useFriendlyHeaders ? worksheetDefn.records.map(function (record) {
        return (0, lodash_1.mapKeys)(record, function (value, key) {
          return worksheetHeaderKeys[key];
        });
      }) : worksheetDefn.records;
      var worksheet_1 = XLSX.utils.json_to_sheet(worksheetData, {
        header: worksheetHeader
      });
      XLSX.utils.book_append_sheet(workbook, worksheet_1, worksheetDefn.name);
    };
    try {
      for (var worksheets_1 = __values(worksheets), worksheets_1_1 = worksheets_1.next(); !worksheets_1_1.done; worksheets_1_1 = worksheets_1.next()) {
        var worksheetDefn = worksheets_1_1.value;
        _loop_1(worksheetDefn);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (worksheets_1_1 && !worksheets_1_1.done && (_a = worksheets_1.return)) _a.call(worksheets_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    var excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    var blob = new Blob([excelBuffer], {
      type: 'application/octet-stream'
    });
    (0, file_saver_1.saveAs)(blob, fileName);
    react_ga4_1.default.event('file_download', {
      'event_category': 'Export',
      'entity_type_name': entityTypeName,
      'user_name': (_b = user.user) === null || _b === void 0 ? void 0 : _b.name,
      'user_email': (_c = user.user) === null || _c === void 0 ? void 0 : _c.email
    });
  };
  var Icon = function () {
    return react_1.default.createElement(entity_type_icon_1.EntityTypeIcon, {
      size: 24,
      entityTypeName: entityTypeName
    });
  };
  var modal = (0, use_modal_1.useModal)();
  var t = (0, use_lang_1.useLang)();
  var label = t('Download Excel File');
  var title = (0, sprintf_js_1.sprintf)(t('Export %s'), defn.pluralLabel);
  var message = (0, sprintf_js_1.sprintf)(t("**%d** %s records prepared for export.  \n\nClick the button below to download Excel file.\n"), sorted.length, defn.label);
  if (!canAdmin) {
    return react_1.default.createElement(error_message_1.ErrorMessage, null, t('You do not have permission to view this page.'));
  }
  return react_1.default.createElement(My.Container, {
    icon: Icon,
    onCancel: function () {
      modal.hide();
    },
    showCancelButton: true,
    cancelLabel: 'Close',
    badge: 'Beta',
    title: title,
    className: cls.name(className)
  }, loading ? react_1.default.createElement(My.Loader, {
    message: "Loading all records. Please wait"
  }) : react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Message, {
    text: message
  }), react_1.default.createElement(My.DownloadButton, {
    onClick: exportToExcel
  }, label)), children);
};
exports.EntityTypeExportLayout = EntityTypeExportLayout;
exports.EntityTypeExportLayout.defaultProps = exports.EntityTypeExportLayoutDefaultProps;
exports.EntityTypeExportLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;